import { c as _c } from "react/compiler-runtime";
import type { ShopPromotionMessage } from "../promotion-messaging";
import React from "react";
import { FiCheckCircle, FiTag } from "react-icons/fi";
import { cx } from "@/lib/tailwind-utils";
interface PromotionProgressProps {
  messages: ShopPromotionMessage[];
  className?: string;
}
export default function PromotionProgress(t0) {
  const $ = _c(7);
  const {
    messages,
    className
  } = t0;
  if (messages.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cx("space-y-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== messages) {
    t2 = messages.map(_temp);
    $[2] = messages;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1} aria-live="polite" aria-label="Promotion progress">{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(message) {
  const unlocked = message.status === "unlocked";
  const Icon = unlocked ? FiCheckCircle : FiTag;
  return <div key={message.id} className={cx("flex items-start gap-2 rounded-xl border px-3 py-2.5 text-caption leading-5", unlocked ? "border-status-success-text/20 bg-status-success-bg text-status-success-text" : "border-primary/20 bg-primary/5 text-foreground")}><Icon className={cx("mt-0.5 h-4 w-4 flex-none", unlocked ? "text-status-success-text" : "text-primary")} /><span>{message.text}</span></div>;
}